// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner {
  margin-top: 80px;
  height: 250px;
  background: #111;
  color: #fff;
  padding: 1rem 6rem;
}

.banner-text h2 {
  font-weight: 400;
  font-size: 27px;
  line-height: 33.75px;
  font-family: Lexend;
}

.filter-btn {
  background: #d74848;
  color: #fff;
  outline: none !important;
  border: none;
  height: 45px;
  border-radius: 5px;
  padding: 0rem 1rem;
  align-items: center;
  justify-content: center;
  display: flex;
}

.refresh-btn {
  background: #d74848;
  color: #fff;
  outline: none !important;
  border: none;
  height: 35px;
  border-radius: 5px;
  padding: 0rem 1rem;
  align-items: center;
  justify-content: center;
  display: flex;
  margin-left: 1rem;
}

.small-text {
  color: #949494;
  font-size: 15px;
  line-height: 18.75px;
  font-weight: 300;
}

.breadcrum {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #757575;
  text-transform: uppercase;
}

.circle-image {
  border: 2px solid #D74848;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  overflow: hidden;
}
.circle-image img {
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 767px) {
  .banner-block {
    display: block !important;
  }
  .banner {
    padding: 2rem 1rem !important;
    margin-top: 30px !important;
  }
  .btn-section {
    display: flex;
    justify-content: flex-end;
  }
  .btn-section button {
    margin-top: 1rem;
    font-size: 14px;
    height: 35px !important;
    padding: 0px 0.7rem;
  }
  .btn-section button img {
    width: 14px;
    height: 14px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .banner {
    padding: 2rem !important;
  }
}
.badge-light {
  padding: 7px 14px;
  background-color: #949494;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/seminav/seminav.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACJ;;AAEA;EACI,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AACJ;AACI;EACI,WAAA;EACA,YAAA;AACR;;AAGA;EACI;IACI,yBAAA;EAAN;EAGE;IACI,6BAAA;IAEA,2BAAA;EAFN;EAKE;IACI,aAAA;IACA,yBAAA;EAHN;EAKM;IACI,gBAAA;IACA,eAAA;IACA,uBAAA;IACA,mBAAA;EAHV;EAKU;IACI,WAAA;IACA,YAAA;EAHd;AACF;AASA;EACI;IACI,wBAAA;EAPN;AACF;AAUA;EACI,iBAAA;EACA,yBAAA;EACA,eAAA;AARJ","sourcesContent":[".banner {\n    margin-top: 80px;\n    height: 250px;\n    background: #111;\n    color: #fff;\n    padding: 1rem 6rem;\n}\n\n.banner-text h2 {\n    font-weight: 400;\n    font-size: 27px;\n    line-height: 33.75px;\n    font-family: Lexend;\n}\n\n.filter-btn {\n    background: #d74848;\n    color: #fff;\n    outline: none !important;\n    border: none;\n    height: 45px;\n    border-radius: 5px;\n    padding: 0rem 1rem;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n}\n\n.refresh-btn {\n    background: #d74848;\n    color: #fff;\n    outline: none !important;\n    border: none;\n    height: 35px;\n    border-radius: 5px;\n    padding: 0rem 1rem;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    margin-left: 1rem;\n}\n\n.small-text {\n    color: #949494;\n    font-size: 15px;\n    line-height: 18.75px;\n    font-weight: 300;\n}\n\n.breadcrum {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    color: #757575;\n    text-transform: uppercase;\n}\n\n.circle-image {\n    border: 2px solid #D74848;\n    border-radius: 50%;\n    width: 36px;\n    height: 36px;\n    overflow: hidden;\n\n    img {\n        width: 100%;\n        height: 100%;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .banner-block {\n        display: block !important;\n    }\n\n    .banner {\n        padding: 2rem 1rem !important;\n        // height: auto !important;\n        margin-top: 30px !important;\n    }\n\n    .btn-section {\n        display: flex;\n        justify-content: flex-end;\n\n        button {\n            margin-top: 1rem;\n            font-size: 14px;\n            height: 35px !important;\n            padding: 0px .7rem;\n\n            img {\n                width: 14px;\n                height: 14px;\n            }\n        }\n    }\n\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n    .banner {\n        padding: 2rem !important;\n    }\n}\n\n.badge-light {\n    padding: 7px 14px;\n    background-color: #949494;\n    font-size: 13px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
